<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="thank-you">
      <Title class="_title" jpn="Purchase completed" />
      <div class="checkbox-image">
        <span class="check"><i class="far fa-check"></i></span>
      </div>
      <div class="description">
        <span class="text">Thank you for your purchase.</span>
        <span class="text">Items selected for shipping will be shipped within 7-14 days.</span>
        <span class="text">We look forward to serving you again.</span>
      </div>
      <div class="button-area">
        <SquareButton
          class="square-button"
          text="Go to home"
          @handleSquareBtnClick="goToTop"
        />
        <SquareButton
          class="square-button"
          text="Buy the same again"
          @handleSquareBtnClick="goReGacha"
        />
      </div>
      <div v-if="isBuyCoin" class="leaf_box">
        <CardList
          class="card-list send"
          :cardListTitle="t('発送するカード')"
          :cardList="getCardList"
          :isPoint="false"
        />
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';
import CardList from '@/components/organisms/CardList.vue';

export default {
  name: 'ThankYou',
  mixins: [t],

  beforeRouteLeave(to, from, next) {
    if (to.name === 'ConfirmGetCardList') {
      next(false);
    } else {
      next();
    }
  },

  components: {
    BaseTemplate,
    SquareButton,
    Title,
    CardList,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentPack: 'pack/currentPack',
      buyPackResult: 'pack/buyPackResult',
    }),
    getCardList() {
      if (this.buyPackResult) {
        return this.buyPackResult.cards;
      }
      return [];
    },
    isBuyCoin() {
      if (this.buyPackResult) {
        return this.buyPackResult.is_buy_coin;
      }
      return false;
    },
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
    // console.log(this.currentPack);
    this.$store.dispatch('pack/setBuyPackResult');
  },

  methods: {
    goToTop() {
      this.$router.push('/');
    },
    goReGacha() {
      this.$router.push(`/pack-detail?packId=${this.currentPack.id}`);
    },
    goContactUs() {
      if (process.env.VUE_APP_LANG_MODE === 'jp') {
        window.open('https://www.iranoan.com/contacts', '_blank');
      } else {
        window.open('https://www.iranoan.com/contacts', '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.leaf_box {
  max-width: 700px;
  margin: 50px auto 0 auto;
}
.thank-you{
  width: 100%;
  max-width: 680px;
  min-height: 100%;
  padding: 30px 30px 30px;
  margin: 0px auto;
  text-align: center;
  color: $black;
  @include appendMap($backgroundStyleMap);
  .checkbox-image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 120px;
      background-color: $mainColor;
      border-radius: 200px;
      .fa-check {
        color: $white;
        font-size: 74px;
      }

    }
  }
  .midashi {
    margin-top: 40px;
    margin-bottom: 30px;
    font-size: 30px;
    font-weight: 700;
  }
  .description{
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    color: $white;
    .text{
      font-family: $notoSans;
      font-size: 16px;
      line-height: 1.6;
    }
    .mb {
      margin-bottom: 24px;
    }
  }
}
.button-area {
  margin: 20px auto;
  width: 260px;
  .square-button:nth-child(2) {
    margin-top: 20px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .leaf_box {
    margin: 50px 10px;
  }
  .thank-you {
    padding: 20px 0 30px 0;
    img {
      max-width: 240px;
      width: 90%;
    }
    .midashi {
      font-size: 24px;
    }
    .description {
      .text {
        font-size: 14px;
      }
    }
  }
}
</style>
